export enum ExportNavigationPaths {

  PORTFOLIO = 'portfolio',
  INCIDENTS = 'incidents',
  GAEB = 'gaeb',
  INSPECTION_DUTY = 'inspection-duty',
  MAINTENANCE_CONTRACT = 'maintenance-contract',
  CALCULATION = "calculation"
}
